import axios from "../axiosInstance";
import { GetCompanyOfferingAccessResponse } from "./types";

export const getCompanyOfferingAccess = async (
  companyUuid: string,
): Promise<GetCompanyOfferingAccessResponse> => {
  const response = await axios.get<GetCompanyOfferingAccessResponse>(
    `/api/private/companies/${companyUuid}/offering-access`,
  );
  return response.data;
};
